import "./UserPanel.css";

import * as m from "../../../../model/model";

import {
  CUser,
  UserAttendance,
  UserFormData,
} from "../../../../model/classes/CUser";
import React, { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";

import { CCourses } from "../../../../model/classes/CCourses";
import ConfirmModal from "../../../../modals/ConfirmModal";
import ModalBase from "../../../../modals/ModalBase";
import NewCourseModal from "../../../../modals/NewCourseModal";
import NewTutoringModal from "../../../../modals/NewTutoringModal";
import { api } from "../../../../api/api";
import { getCoursesThunk } from "../../../../store/slices/adminThunks";
import { useForm } from "react-hook-form";
import { useModal } from "../../../../context/ModalContext";

interface UserPanelProps {
  onSave?: (userData: m.User) => void;
}

export default function UserPanel({ onSave }: UserPanelProps) {
  // const [userData, setUserData] = useState<m.User>(user);
  const coursesResponse = useAppSelector(
    (state: RootState) => state.admin.coursesResponse
  );
  const selectedUser = useAppSelector(
    (state: RootState) => state.admin.selectedUser
  );
  const [courses, setCourses] = useState<CCourses>();
  const [cuser, setCUser] = useState<CUser>();
  const dispatch = useAppDispatch();
  const { showModal, hideModal } = useModal();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isDirty },
    reset,
  } = useForm<UserFormData>({});

  useEffect(() => {
    dispatch(getCoursesThunk());
  }, [dispatch]);

  useEffect(() => {
    if (selectedUser) {
      const newUser = new CUser(selectedUser);
      setCUser(newUser);
    }
  }, [selectedUser, reset]);

  useEffect(() => {
    if (cuser) reset(cuser.formData()); // Reset form values when user changes
  }, [cuser, reset]);

  useEffect(() => {
    if (coursesResponse) setCourses(new CCourses(coursesResponse));
  }, [coursesResponse]);

  const handleAddCourse = (e: React.MouseEvent) => {
    e.preventDefault();
    showModal(
      <NewCourseModal
        onConfirm={(data) => {
          console.log("Add course", data);
          cuser?.addCourse(data.uid, courses);
          setCUser(cuser?.clone());
          console.log("user", cuser?.json);
          hideModal();
        }}
      />
    );
  };

  const handeRemoveCourse = (e: React.MouseEvent, key: string) => {
    e.preventDefault();
    const name = courses?.getCourse(key)?.name;
    showModal(
      <ConfirmModal
        message={`Remove ${name}?`}
        onConfirm={() => {
          console.log("Remove course", key);
          cuser?.removeCourse(key);
          setCUser(cuser?.clone());
        }}
        onCancel={hideModal}
      />
    );
  };

  const handleAddTutoring = (e: React.MouseEvent) => {
    e.preventDefault();
    showModal(<NewTutoringModal onConfirm={console.log} />);
  };

  const handeRemoveTutoring = (e: React.MouseEvent, key: string) => {
    e.preventDefault();
    const name = courses?.getTutoring(key)?.name;
    showModal(
      <ConfirmModal
        message={`Remove ${name}?`}
        onConfirm={() => {
          console.log("Remove tutoring", key);
          cuser?.removeTutoring(key);
          setCUser(cuser);
        }}
        onCancel={hideModal}
      />
    );
  };

  const viewOrder = (e: React.MouseEvent, key: string) => {
    e.preventDefault();
    api.admin.orders
      .getOrder(key)
      .then((order) => {
        const json = JSON.stringify(order, null, 2);
        showModal(
          <ModalBase
            header="Order"
            body={<pre style={{ width: "100%" }}>{json}</pre>}
            footer={
              <>
                <div />
                <button className="loa-button" onClick={hideModal}>
                  Close
                </button>
              </>
            }
          />
        );
      })
      .catch((e) => {
        showModal(
          <ModalBase
            header="Error"
            body={e.message}
            footer={
              <>
                <div />
                <button className="loa-button" onClick={hideModal}>
                  Close
                </button>
              </>
            }
          />
        );
      });
  };

  const viewAttendance = (
    e: React.MouseEvent,
    att: UserAttendance[] | undefined
  ) => {
    e.preventDefault();
    showModal(
      <ModalBase
        header="Attendance"
        body={
          <div style={{ margin: "0 32px" }}>
            {att?.map((a) => (
              <pre key={a.date}>
                {a.date} {a.lesson}
              </pre>
            ))}
          </div>
        }
        footer={
          <>
            <div />
            <button className="loa-button" onClick={hideModal}>
              Close
            </button>
          </>
        }
      />
    );
  };

  const onSubmit = async (data: UserFormData) => {
    try {
      if (!cuser) return;

      // Update the user with form data
      console.log("Saving user", data, cuser.json);

      // Save to the API
      await api.admin.user.updateUser(data as any).then((users) => {
        console.log("User saved", users);
        // Update the user in the store
        dispatch({ type: "admin/setUsers", payload: users });
      });

      // Call onSave if provided
      if (onSave) {
        //onSave(cuser.json);
      }

      // Show success message
      showModal(
        <ModalBase
          header="Success"
          body="User saved successfully"
          footer={
            <>
              <div />
              <button className="loa-button" onClick={hideModal}>
                Close
              </button>
            </>
          }
        />
      );
    } catch (error: any) {
      // Show error message
      showModal(
        <ModalBase
          header="Error"
          body={`Failed to save user: ${error.message}`}
          footer={
            <>
              <div />
              <button className="loa-button" onClick={hideModal}>
                Close
              </button>
            </>
          }
        />
      );
    }
  };

  if (!cuser) return null;

  const userName = watch("name");

  return (
    <div className="user-container">
      <form className="user-form" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="uid" value={cuser.key} />
        <div className="form-subtitle">{userName}</div>
        <div className="user-label">Key</div>
        <div className="user-field ">
          <input
            {...register("key")}
            readOnly={true}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Admin</div>
        <div className="user-field ">
          <input
            type="checkbox"
            {...register("admin")}
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Name</div>
        <div className="user-field gc-span3">
          <input
            {...register("name")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Email</div>
        <div className="user-field gc-span3">
          <input
            {...register("email")}
            readOnly={true}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Address</div>
        <div className="user-field gc-span3">
          <input
            {...register("address.line1")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label"></div>
        <div className="user-field gc-span3">
          <input
            {...register("address.line2")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Postal Code</div>
        <div className="user-field gc-span3">
          <input
            {...register("address.postalCode")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">City</div>
        <div className="user-field gc-span3">
          <input
            {...register("address.city")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        <div className="user-label">Country</div>
        <div className="user-field gc-span3">
          <input
            {...register("address.country")}
            type="text"
            data-1p-ignore="true"
            autoComplete="off"
          />
        </div>
        {cuser.hasCourse && (
          <>
            <div className="form-subtitle">Current Course</div>
            <div className="user-label">Course</div>
            <div className="user-field">
              <select {...register("currentCourse")}>
                {cuser.coursesList.map(({ key }) => (
                  <option key={key} value={key}>
                    {courses?.getCourse(key)?.name}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
        <div className="form-subtitle">Courses</div>
        {cuser.coursesList.map(({ key }) => {
          const purchase = cuser.purchases?.[key];
          return (
            <React.Fragment key={key}>
              <input
                type="hidden"
                value={key}
                {...register(`courses.${key}.key`)}
              />
              <div className="user-field title">
                {courses?.getCourse(key)?.name}
              </div>
              <div className="user-label">key</div>
              <div className="user-field bold">{key}</div>
              <div className="user-label">Start Date</div>
              <div className="user-field">
                <input
                  type="date"
                  {...register(`courses.${key}.startDate`)}
                  data-1p-ignore="true"
                  autoComplete="off"
                />
              </div>
              <div className="user-label">End Date</div>
              <div className="user-field">
                <input
                  type="date"
                  {...register(`courses.${key}.endDate`)}
                  data-1p-ignore="true"
                  autoComplete="off"
                />
              </div>
              <div className="user-label">Current Lesson</div>
              <div className="user-field">
                <select {...register(`courses.${key}.progress`)}>
                  {courses?.getCourse(key)?.lessons?.map((lesson) => (
                    <option key={lesson.uid} value={lesson.uid}>
                      {lesson.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="user-label gc-span4 just-right">
                {purchase && (
                  <button
                    className="loa-button"
                    onClick={(e) => viewOrder(e, purchase.order)}
                  >
                    View Order
                  </button>
                )}
                <button
                  className="loa-button"
                  onClick={(e) =>
                    viewAttendance(e, cuser.getAttendanceForLesson(key))
                  }
                >
                  View Attendance
                </button>
                <button
                  className="loa-button"
                  onClick={(e) => handeRemoveCourse(e, key)}
                >
                  Remove Course...
                </button>
              </div>
            </React.Fragment>
          );
        })}
        <div className="user-label gc-span4 just-center">
          <button className="loa-button" onClick={handleAddCourse}>
            Add New Course
          </button>
        </div>
        <div className="form-subtitle">Tutorings</div>
        {cuser.tutoringsList.map(({ key }) => (
          <React.Fragment key={key}>
            <div className="user-field title">
              {courses?.getTutoring(key)?.name}
            </div>
            <div className="user-label">key</div>
            <div className="user-field bold">{key}</div>
            <div className="user-label">Start Date</div>
            <div className="user-field">
              <input type="date" {...register(`tutorings.${key}.startDate`)} />
            </div>
            <div /> <div />
            <div className="user-label gc-span4 just-right">
              <button
                className="loa-button"
                onClick={(e) => handeRemoveTutoring(e, key)}
              >
                Remove Tutoring...
              </button>
            </div>
          </React.Fragment>
        ))}
        <div className="user-label gc-span4 just-center">
          <button className="loa-button" onClick={handleAddTutoring}>
            Add New Tutoring
          </button>
        </div>
        <div className="gc-span4">
          <hr />
        </div>
        <button type="submit" className="ml12 loa-button">
          Save
        </button>
      </form>
    </div>
  );
}
